export enum StorageCaseDimensionsActionTypes {
  STORAGE_SET_CASE_DIMENSIONS = "STORAGE_SET_CASE_DIMENSIONS",
}
